module.exports = __webpack_public_path__ + "static/media/copy-icon.d01ea103.svg";